<template>
    <div class="voucher_detail_wrap fc">
        <mt-swipe :auto="0">
            <mt-swipe-item>
                <img :src="imgBaseUrl + productInfo.logo" alt />
            </mt-swipe-item>
        </mt-swipe>
        <div class="coupon_info fc">
            <span class="price">￥{{ productInfo.price }}</span>
            <span class="grey_txt"
                >官方价：￥{{ productInfo.martetprice }}</span
            >
            <h3>{{ productInfo.title }}</h3>
        </div>
        <div class="row fr ac jsb">
            <span class="row_name">购买份数</span>
            <div class="num_box fr ac">
                <span class="operate" @click="minusNum">-</span>
                <span class="num_txt">{{ num }}</span>
                <span class="operate" @click="addNum">+</span>
            </div>
        </div>
        <div class="row fr ac jsb">
            <span class="row_name">有效日期</span>
            <span class="valid_date">24小时内有效</span>
        </div>
        <img
            :src="imgBaseUrl + productInfo.descriptionpic"
            alt=""
            class="detail_pic"
        />
        <div class="footer fr">
            <div class="service fc ac jc" @click="service">
                <img src="../../../static/imgs/mall/contact.png" alt />
                <span>联系客服</span>
            </div>
            <button
                class="buy_btn"
                @click="createOrder"
            >
                立即购买￥{{productInfo.price * num}}
            </button>
        </div>
    </div>
</template>

<script>
import { Swipe, SwipeItem, Toast } from "mint-ui";
export default {
    data() {
        return {
            gid: this.$route.query.gid,
            productInfo: {},
            imgBaseUrl: this.$global.imgBaseUrl,
            num: 1,
        };
    },
    components: {},
    created() {
        this.productInfo = JSON.parse(
            decodeURIComponent(this.$route.query.info)
        );
        console.log(this.productInfo);
    },
    methods: {
        addNum() {
            this.num++;
        },
        minusNum() {
            if (this.num > 1) {
                this.num--;
            } else {
                Toast({
                    message: "不能再减了",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox",
                });
            }
        },
        createOrder() {
            this.$post({
                method: "starbucks.member.coupon.order.create",
                auth_code: this.getLocal("auth_code"),
                productid: this.productInfo.id,
                qty: this.num,
            }).then((res) => {
                if (res.success) {
                    let tradeno = res.data.tradeno;
                    let appkey = this.$global.appkey;
                    if (
                        appkey == "dumovie_iOS" ||
                        appkey == "dumovie_Android"
                    ) {
                        window.location.href =
                            "dumovie://com.dumovie/order/pay/goods/" + tradeno;
                    } else {
                        this.$router.push({
                            path: "/confirmOrder",
                            query: {
                                tradeno: tradeno,
                            },
                        });
                    }
                } else {
                    console.log(res)
                    Toast({
                        message: res.msg ? res.msg : res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox",
                    });
                }
            });
        },
        service() {
            window.location.href = "tel://400-820-1350";
        },
    },
};
</script>
<style lang="scss">
.voucher_detail_wrap {
    .mint-swipe {
        width: 100%;
        height: 750px;
        img {
            width: 100%;
            height: 750px;
        }
    }
    .coupon_info {
        padding: 30px;
        box-sizing: border-box;
        background: #fff;
        margin-bottom: 20px;
        .price {
            font-size: 40px;
            color: #e42f46;
        }
        .grey_txt {
            font-size: 24px;
            color: #999;
            margin: 18px 0;
        }
        h3 {
            font-size: 30px;
        }
    }
    .row {
        padding: 30px;
        box-sizing: border-box;
        background: #fff;
        margin-bottom: 20px;
        .row_name {
            font-size: 32px;
        }
        .num_box {
            height: 48px;
            line-height: 48px;
            text-align: center;
            border: 1px solid #dededf;
            font-size: 28px;
            border-radius: 10px;
            .operate {
                width: 48px;
            }
            .num_txt {
                width: 74px;
                border-right: 1px solid #dededf;
                border-left: 1px solid #dededf;
            }
        }
        .valid_date {
            font-size: 28px;
            color: #e42f46;
        }
    }
    .detail_pic {
        width: 100%;
        height: 2840px;
        margin-bottom: 130px;
    }
    .footer {
        width: 100%;
        position: fixed;
        bottom: 0;
        .service {
            width: 190px;
            height: 100px;
            background: #fff;
            img {
                width: 36px;
                height: 36px;
                margin-bottom: 10px;
            }
            span {
                font-size: 20px;
                color: #999;
            }
        }
        button {
            width: 560px;
            height: 100px;
            line-height: 100px;
            font-size: 32px;
        }
        .buy_btn {
            background: #307048;
            color: #fff;
        }
        .sold_out {
            background: #eee;
            color: #999;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/xbk/xbkVoucherDetail.vue